import { FieldLabel } from '@measured/puck';
import React from 'react';
import CustomTooltip from '../../../components/common/tooltip';
import { toolTipInfo } from '../../utils/constants';

interface InputProps {
  value: string | undefined;
  onChange: (_value: string) => void;
  label: string | undefined;
  tooltip: string | undefined;
}

const ColorPicker = ({ value, onChange, label, tooltip }: InputProps) => {
  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (/^#[a-zA-Z0-9]*$/.test(newValue) && newValue.length <= 7) {
      onChange(newValue);
    }
  };
  return (
    <FieldLabel
      label={
        (
          <CustomTooltip title={tooltip as keyof typeof toolTipInfo}>
            <span>{label}</span>
          </CustomTooltip>
        ) as React.ReactNode as string
      }
      el="div"
      className="w-full">
      <div className="grid items-center gap-2 grid-cols-[max-content_80%]">
        <input
          type="color"
          id="colorPicker"
          value={value}
          className="w-10 h-full"
          onChange={handleTextChange}
        />
        <input
          className="rounded-md"
          type="text"
          id="hexColor"
          value={value}
          onChange={handleTextChange}
        />
      </div>
    </FieldLabel>
  );
};

export default ColorPicker;
